import { Component, OnInit, Input } from '@angular/core';
import { practitionerI } from 'app/core/interfaces/practitioner';
import { identifier } from 'app/core/models/Organization';
import { BaseComponent } from 'app/modules/shared/components/base.component';

@Component({
  selector: 'page-data-person',
  templateUrl: './data-person.component.html',
  styleUrls: ['./data-person.component.scss'],
})
export class DataPersonComponent extends BaseComponent implements OnInit {
  @Input() public person: any = <any>{};
  @Input() type: 'Person' | 'Consulta' = 'Person';

  public telecom: any;
  public identifier: any;

  ngOnInit() {
    this.initValues();

    this.telecom = this.extractContactInfo(this.person?.telecom);
    this.identifier = this.extractIdentifiers(this.person?.identifier);
  }

  openAvatarForm() {
    this.dialog.openAvatarForm({
      title: 'Trocar avatar',
      component: 'avatar-form',
      param: { id: this.person?.id as number },
    });
  }

  initValues() {
    const fields = ['cpf', 'phone', 'mobile'];
    fields.map((field: string) => {
      if (this.person && !this.person[field]) {
        this.person[field] = '';
      }
    });
  }

  extractContactInfo(telecom: any[]) {
    let email: string | null = null;
    let phone: string | null = null;
    let mobile: string | null = null;

    telecom.forEach((telecom) => {
      const { value, use, system } = telecom;
      if (system === 'email') {
        email = value;
      } else if (system === 'phone') {
        phone = value;
      } else if (system === 'mobile') {
        mobile = value;
      }
    });
    return { email, phone, mobile };
  }

  private extractIdentifiers(identifiers: identifier[]) {
    let CPF: string | null = null;
    let CRM: string | null = null;
    let CNPJ: string | null = null;

    identifiers.forEach((identifier) => {
      const { system, value } = identifier;

      if (system === 'CPF') {
        CPF = value;
      } else if (system === 'CRM') {
        CRM = value;
      } else if (system === 'CNPJ') {
        CNPJ = value;
      }
    });

    return { CPF, CRM, CNPJ };
  }

  getPrefix(practitioner: practitionerI) {
    if (practitioner.gender) {
      return practitioner.gender == 'Female' ? 'Dra. ' : 'Dr. ';
    }
    return '';
  }
}
